var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { repairService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
var ArchiveDataService = /** @class */ (function () {
    function ArchiveDataService() {
    }
    /**
     * 村委资料查询
     */
    ArchiveDataService.prototype.get = function (idNo, loading) {
        return this.netService.send({
            server: repairService.archiveDataController.get,
            data: {
                idNo: idNo
            },
            loading: loading
        });
    };
    ArchiveDataService.prototype.detailList = function (idNo, page, loading) {
        return this.netService.send({
            server: repairService.archiveDataController.detailList,
            data: {
                idNo: idNo
            },
            page: page,
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], ArchiveDataService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], ArchiveDataService.prototype, "get", null);
    return ArchiveDataService;
}());
export { ArchiveDataService };
